import { InfiniteQueryConfig, useInfiniteQuery } from "react-query";
import { merchants } from "services/merchants";

const buildListTeamMembersKeys = (merchantId: string, teamId: string) => {
    const compositeIds = { merchantId, teamId };

    return ["MERCHANTS", compositeIds];
};

export const fetchMoreDelayed = (
    canFetchMore: boolean,
    isFetchingMore: boolean | string,
    isFetching: boolean,
    fetchMore: () => void,
) => {
    if (canFetchMore && !isFetchingMore && !isFetching) {
        process.nextTick(() => fetchMore());
    }
};

export const useFetchListTeamMembers = (
    merchantId: string,
    teamId: string,
    params: Partial<nuorder.merchant.v1.ListTeamMembersRequest> = { page_size: 30 },
    options?: Partial<InfiniteQueryConfig<nuorder.merchant.v1.ListMembersResponse, Error>>,
) => {
    const { page_size } = params;
    return useInfiniteQuery<nuorder.merchant.v1.ListMembersResponse, Error>(
        merchantId && teamId && buildListTeamMembersKeys(merchantId, teamId),
        (_cacheKey, _, page_token: string) => {
            return merchants.fetchListTeamMembers(merchantId, teamId, {
                ...params,
                ...(page_token ? { page_token } : {}),
            });
        },
        {
            ...options,
            getFetchMore: (lastResponse: nuorder.merchant.v1.ListMembersResponse) => {
                return lastResponse.members?.length &&
                    lastResponse.members.length >= page_size &&
                    lastResponse.next_page_token
                    ? lastResponse.next_page_token
                    : null;
            },
        },
    );
};
